/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Delete_TitleInputs */

const en_admin_posts_delete_title = /** @type {(inputs: Admin_Posts_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Post`)
};

/**
* | output |
* | --- |
* | "Delete Post" |
*
* @param {Admin_Posts_Delete_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_delete_title = /** @type {((inputs?: Admin_Posts_Delete_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Delete_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_delete_title(inputs)
});
export { admin_posts_delete_title as "admin.posts.delete_title" }